import styled from '@emotion/styled';
import { Link } from 'react-router';

const StyledLink = styled(Link)`
  margin-top: 10px;
  font-size: 14px;
  color: #007bff;
  text-decoration: none;
  text-align: center;

  &:hover {
    text-decoration: underline;
  }
`;

interface LinkProps {
  to: string;
  displayName: string;
  id?: string;
  state?: unknown;
}

export function StyledLoginLink({ to, displayName, id, state }: LinkProps) {
  return (
    <StyledLink id={id} to={to} state={state}>
      {displayName}
    </StyledLink>
  );
}
